                    
var addHeadings = () => {
  
  $( ".step1" ).prepend("<p class=\"steps-heading\">Step 1 of 3</p>");
  $( ".step2" ).prepend("<p class=\"steps-heading\">Step 2 of 3 - Select available date and time from the calendar</p>");

};

setTimeout(addHeadings, 3000);

var addHeading3 = () => {

 $( ".step3" ).prepend("<p class=\"steps-heading steps-heading-3\">Step 3 of 3 - Enter your details and confirm your appointment</p>");
  
};

var addEvent3 = () => {
  var cb2 = document.getElementsByClassName('continue-button')[1];
  
  $( cb2 ).attr('id', 'continue-button-2');
  
  $( '#continue-button-2' ).bind("click", addHeading3);

}

setTimeout(addEvent3, 3000);